import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
 
const SubmissionStatusModal = ({ open, onClose, isSuccess, message, status }) => {
  const getMessage = () => {
    if (status) {
      switch (status) {
        case 'success':
          return 'JS Logo submitted successfully!';
        case 'error':
          return 'Failed to submit JS Logo. Please try again.';
        default:
          return '';
      }
    }
    return message || (isSuccess ? 'Submission Successful!' : 'Submission Failed!');
  };
 
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          textAlign: 'center',
          wordWrap: 'break-word', // Ensure text wraps properly
          whiteSpace: 'normal',
          borderRadius: 2,
        }}
      >
        {isSuccess ? (
          <>
            <CheckCircleIcon color="success" sx={{ fontSize: 40 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {getMessage()}
            </Typography>
          </>
        ) : (
          <>
            <ErrorIcon color="error" sx={{ fontSize: 40 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {getMessage()}
            </Typography>
          </>
        )}
 
        {/* OK Button */}
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ mt: 4, bgcolor: 'error.main', color: 'white', '&:hover': { bgcolor: 'error.dark' } }} // Setting red background
        >
          Ok
        </Button>
 
 
 
      </Box>
    </Modal>
  );
};
 
export default SubmissionStatusModal;